export default {
  tr: 'https://gorillaenergy.com.tr',
  ar: 'https://gorillaultimate.ae',
  ru: 'https://gorillaenergy.ru',
  usa: 'https://gorillaenergy.us'
}
